import { FC } from "react";
import { Fade, IconButton, Stack } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { useAppAbility } from "../../../../../../../../../services/permissions";
import { TypographyWithTooltip } from "../../../../../../../../common/TypographyWithTooltip";

interface WidgetNameDefaultViewProps {
  name: string;
  hovered: boolean;
  toggleEditMode: (action: any) => any;
}

export const WidgetNameDefaultView: FC<WidgetNameDefaultViewProps> = ({
  name,
  hovered,
  toggleEditMode,
}) => {
  const { cannot } = useAppAbility();
  const canNotEditWidget = cannot("edit", "dashboard");

  return (
    <Stack
      alignSelf="start"
      direction="row"
      spacing={1}
      overflow="hidden"
      alignItems="center"
      flexGrow={0}
    >
      <TypographyWithTooltip variant="body1" fontWeight="bold" title={name} />

      {!canNotEditWidget && (
        <Fade in={hovered}>
          <IconButton size="small" onClick={toggleEditMode}>
            <EditOutlinedIcon fontSize="small" />
          </IconButton>
        </Fade>
      )}
    </Stack>
  );
};
